/* eslint-disable max-len,react-hooks/exhaustive-deps,no-use-before-define,no-param-reassign,react/jsx-props-no-spreading,prefer-destructuring */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Space, Button, Table, Row, Col, Tooltip, Form, Select } from "antd";
import { jwtDecode } from "jwt-decode";
import { v4 as uuid } from "uuid";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import Modal from "antd/lib/modal/Modal";
import axios from "axios";
import { formatDate, getAccountFullName, round, toHttpFormat } from "../../lib/utils";
import "../../styles/filters-form.less";
import "./BulkBills.less";
import {
  bulkDeleteBills,
  bulkNotifyBills,
  bulkHardNotifyBills,
  bulkSendBills,
} from "../../store/slices/bills";
import { exportToXLS } from "../../store/slices/xlsExport";
import AuthService from "../../services/AuthService";
import { getAgreementByAgrId } from "../../lib/routes/accounts";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_BILLS_WRITE } from "../../lib/const/permissions";
import SpanNumberFormat from "../common/SpanNumberFormat";
import useDebounce from "../../lib/hooks/useDebounce";
import { ReactComponent as PrepaidBillIcon } from "../../img/payment_icons/prepaid-bill.svg";
import { ReactComponent as PostpaidBillIcon } from "../../img/payment_icons/postpaid-bill.svg";
import { ReactComponent as BillFactureIcon } from "../../img/payment_icons/bill-facture.svg";
import { ReactComponent as InvoiceIcon } from "../../img/payment_icons/invoice.svg";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { fetchDocumentTemplates } from "../../store/slices/documentTemplates";
import { BulkBillsSearchFilters } from "./BulkBillsSearchFilters/BulkBillsSearchFilters";
import { fetchReportType } from "../../store/slices/rtkDictionaries";
import { useLoading } from "../../lib/hooks/useLoading";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const styles = {
  selectTemplate: {
    width: "100%",
  },
  selectFormat: {
    width: "100%",
  },
  selectReportTypeId: {
    width: "100%",
  },
};

const BulkBills = ({
  companyIdentityAttribute,
  dataBills,
  handleSearchBills,
  resetSearch,
  billsSearchParams,
  isLoadData,
  form,
}) => {
  const { display_name: initiator } = jwtDecode(AuthService.getCurrentUser());
  const dispatch = useDispatch();
  const { billStatus: billStatuses, billType: billTypes, payStatus: payStatuses } = useSelector(
    (state) => state.rtkDictionaries
  );

  const [filtersCollapseState, setFiltersCollapsState] = useState("unfolded");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [activeModal, setActiveModal] = useState(null);
  const areFooterButtonsDisabled = isEmpty(selectedRowKeys);
  const isModalVisible = !!activeModal;

  const {
    billsLoading,
    extendedSearchBillsLoading,
    bulkHardNotifyBillsLoading,
    bulkNotifyBillsLoading,
    bulkSendBillsLoading,
  } = useSelector((state) => state.bills);

  const { templates, templatesLoading } = useSelector((state) => state.documentTemplates);
  const { reportType } = useSelector((state) => state.rtkDictionaries);
  const [reportModalForm] = Form.useForm();
  const [billsMoDataModal, setBillsMoDataModal] = useState({});

  const { Option } = Select;

  const resetSearchPaymentsAndResetSetSelectedRowKeys = () => {
    resetSearch();
    setSelectedRowKeys([]);
  };

  const getGoalIcon = (goalTypeId) => {
    const icons = {
      1: [<PrepaidBillIcon key={uuid()} />, "Счет на предоплату"],
      2: [<PostpaidBillIcon key={uuid()} />, "Счет на постоплату"],
      3: [<BillFactureIcon key={uuid()} />, "Счет-фактура"],
      4: [<InvoiceIcon key={uuid()} />, "Инвойс"],
      // Временно добавлены для отображения значков (картинку нарисуют позже)
      5: [<InvoiceIcon key={uuid()} />, "Предложение"],
      6: [<InvoiceIcon key={uuid()} />, "Продукт"],
    };
    const [icon, title] = icons[goalTypeId];
    return (
      <div style={{ marginRight: "5px", width: "24px", height: "24px" }}>
        <Tooltip title={title}>{icon}</Tooltip>
      </div>
    );
  };

  const [columns, setColumns] = useState([
    {
      title: "ID счета",
      dataIndex: "id",
      key: "id",
      width: 100,
      hidden: true,
    },
    {
      title: "Клиент",
      dataIndex: "fullName",
      key: "fullName",
      width: 180,
    },
    {
      title: "Номер договора",
      dataIndex: "agreementNumber",
      key: "agreementNumber",
    },
    {
      title: "Номер счета",
      dataIndex: "billNumber",
      key: "billNumber",
      width: 160,
      render: (billNumber, record) => (
        <div style={{ display: "flex" }}>
          {getGoalIcon(record.billTypeId)}
          <div
            onClick={async (e) => {
              e.stopPropagation();
              const { data } = await axios(getAgreementByAgrId(record.agreementId));
              const targetUrl = `/accounts/${data.accountId}/bills/details/search?=${record.id}`;
              window.open(targetUrl);
            }}
            className="reject-traffic-link"
            aria-hidden="true"
            style={{ cursor: "pointer" }}
          >
            {billNumber}
          </div>
        </div>
      ),
    },
    {
      title: "Дата счета",
      dataIndex: "billDate",
      key: "billDate",
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (value) => <span className="bulk-bills__period">{value}</span>,
    },
    {
      title: "Сумма счета",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => SpanNumberFormat({ amount }),
    },
    {
      title: "К оплате",
      dataIndex: "amountLeft",
      key: "amountLeft",
      render: (amountLeft) => SpanNumberFormat({ amount: amountLeft }),
    },
    {
      title: "Статус счета",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Статус оплаты",
      dataIndex: "payStatus",
      key: "payStatus",
    },
    {
      title: "Оплата от юрлица",
      dataIndex: "fromAnotherCompany",
      key: "fromAnotherCompany",
    },
    {
      title: "Тип счета",
      dataIndex: "paymentType",
      key: "paymentType",
    },
  ]);

  const billsData =
    isLoadData &&
    dataBills &&
    dataBills
      .filter(({ id }) => selectedRowKeys.includes(id))
      .map((b) => {
        const data = { ...b, initiator };
        return {
          billId: b.id,
          data: JSON.stringify(data),
        };
      });

  const getTableHeight = () => (filtersCollapseState === "unfolded" ? 400 : 560);

  const tableData =
    isLoadData &&
    checkIsLoaded(billsLoading) &&
    dataBills &&
    dataBills.map(
      ({
        agreement,
        billNumber,
        fromDate,
        periodFrom,
        periodTo,
        billStatusId,
        amount,
        amountLeft,
        billTypeId,
        id,
        payStatusId,
        agreementId,
      }) => {
        const billDate = fromDate ? formatDate.toDisplayFormat(fromDate) : "";
        const period = [
          periodFrom ? formatDate.toDisplayFormat(periodFrom) : "",
          periodTo ? formatDate.toDisplayFormat(periodTo) : "",
        ].join("\n");
        const { name: status } = billStatuses.find(({ id: stId }) => stId === billStatusId) || "";
        const { name: paymentType } = billTypes.find(({ id: btId }) => btId === billTypeId) || "";
        const { name: payStatus } =
          payStatuses.find(({ id: psId }) => String(psId) === String(payStatusId)) || "";
        return {
          key: id,
          id,
          billNumber,
          fullName: agreement?.account ? getAccountFullName(agreement?.account) : "",
          agreementNumber: agreement?.agreementNumber,
          amount: round(amount),
          amountLeft: round(amountLeft),
          billDate,
          period,
          status,
          paymentType,
          payStatus,
          fromAnotherCompany: "Нет",
          agreementId,
          billTypeId,
        };
      }
    );

  const handleDelete = useDebounce(() => {
    dispatch(bulkDeleteBills({ bills: billsData, initiator }));
  }, 300);

  const handleNotify = useDebounce(() => {
    dispatch(bulkNotifyBills({ bills: billsData, initiator }));
  }, 300);

  const handleHardNotify = useDebounce(() => {
    dispatch(bulkHardNotifyBills({ bills: billsData, initiator }));
  }, 300);

  const handleSend = useDebounce(() => {
    const params = { ...billsMoDataModal, bills: billsData, initiator };

    delete params.reportTypeId;

    if (billsMoDataModal.formatType === "PDF") {
      delete params.formatType;
    }

    console.log({ params });

    dispatch(bulkSendBills(params));
  }, 300);

  const handlers = {
    notify: handleNotify,
    hardNotify: handleHardNotify,
    delete: handleDelete,
    send: handleSend,
  };

  const modalText = {
    notify: "отправку сообщений",
    hardNotify: "отправку сообщений",
    delete: "удаление счетов",
    send: "отправку счетов",
  };

  const { isLoading, startLoading, stopLoading } = useLoading();

  const renderFooter = () => {
    const handleClick = (taskType) => () => setActiveModal(taskType);

    const handleExport = () => {
      startLoading();
      const selectedBills = dataBills && dataBills.filter(({ id }) => selectedRowKeys.includes(id));
      const exportedData = {
        fileName: `Счета_${formatDate.toDisplayFormat(moment())}`,
        title: "Выгрузка данных в формате xls",
        description: "Выгрузка данных",
        author: initiator,
        header: [
          { name: "fullName", title: "Наименование", type: "String" },
          { name: "agreementNumber", title: "Номер договора", type: "String" },
          { name: "billNumber", title: "Номер счета", type: "String" },
          { name: "fromDate", title: "Дата счета", type: "LocalDate" },
          { name: "period", title: "Период", type: "String" },
          { name: "status", title: "Статус", type: "String" },
          { name: "amount", title: "Сумма счета", type: "Double" },
          { name: "amountLeft", title: "К оплате", type: "Double" },
          { name: "payStatus", title: "Статус оплаты", type: "String" },
          {
            name: "fromAnotherCompany",
            title: "Оплата от юрлица",
            type: "String",
          },
          { name: "paymentType", title: "Тип счета", type: "String" },
        ],
        data: selectedBills.map((bill) => {
          const period = [
            bill.periodFrom ? formatDate.toDisplayFormat(bill.periodFrom) : "",
            bill.periodFrom ? formatDate.toDisplayFormat(bill.periodTo) : "",
          ].join(" - ");
          const { name: status } =
            billStatuses.find(({ id: stId }) => stId === bill.billStatusId) || "";
          const { name: paymentType } =
            billTypes.find(({ id: btId }) => btId === bill.billTypeId) || "";
          const { name: payStatus } =
            payStatuses.find(({ id: psId }) => String(psId) === String(bill.payStatusId)) || "";
          return {
            fullName: bill?.agreement?.account ? getAccountFullName(bill?.agreement?.account) : "",
            agreementNumber: bill?.agreement?.agreementNumber,
            billNumber: bill.billNumber,
            fromDate: bill.fromDate ? formatDate.toDisplayFormat(bill.fromDate) : "",
            period,
            status,
            amount: round(bill?.amount),
            amountLeft: round(bill?.amountLeft),
            payStatus,
            fromAnotherCompany: "Нет",
            paymentType,
          };
        }),
      };

      dispatch(exportToXLS(exportedData)).finally(stopLoading);
    };

    if (hasAccess(MENU_BILLS_WRITE)) {
      return (
        <Space className="buttons-container">
          <Button
            type="primary"
            disabled={areFooterButtonsDisabled}
            loading={isLoading}
            onClick={handleExport}
          >
            Выгрузить список в XLS
          </Button>
          <Button
            type="primary"
            disabled={areFooterButtonsDisabled}
            loading={checkIsLoading(bulkSendBillsLoading)}
            onClick={handleClick("send")}
          >
            Отправить счета
          </Button>
          <Button
            type="primary"
            disabled={areFooterButtonsDisabled}
            loading={checkIsLoading(bulkNotifyBillsLoading)}
            onClick={handleClick("notify")}
          >
            Напомнить об оплате
          </Button>
          <Button
            type="primary"
            disabled={areFooterButtonsDisabled}
            loading={checkIsLoading(bulkHardNotifyBillsLoading)}
            onClick={handleClick("hardNotify")}
          >
            Напомнить об оплате с пометкой !
          </Button>
        </Space>
      );
    }
    return null;
  };

  useEffect(() => {
    dispatch(fetchReportType());
  }, []);

  // Загрузка шаблонов
  useEffect(() => {
    const params = {
      reportTypeId: billsMoDataModal.reportTypeId,
      onDate: toHttpFormat(moment()),
    };
    dispatch(fetchDocumentTemplates(params));
  }, [billsMoDataModal?.reportTypeId]);

  const renderSelectReportType = () => (
    <Select
      placeholder="Выберите тип"
      onChange={(value) => {
        setBillsMoDataModal({
          ...billsMoDataModal,
          reportTypeId: value,
          reportId: undefined,
        });
        reportModalForm.setFieldsValue({ reportId: undefined });
      }}
      value={billsMoDataModal.reportTypeId}
      allowClear
    >
      {reportType?.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  );

  const renderSelectTemplates = () => (
    <Select
      placeholder="Выберите шаблон"
      style={styles.selectTemplate}
      loading={templatesLoading === loadingStatusCodes.pending}
      onChange={(value) => {
        setBillsMoDataModal({
          ...billsMoDataModal,
          reportId: value,
        });
      }}
      disabled={!billsMoDataModal.reportTypeId || templatesLoading === loadingStatusCodes.pending}
      allowClear
    >
      {templates &&
        templates.length !== 0 &&
        templates.map((item) => (
          <Option key={uuid()} value={item.id}>
            {item.defaultTemplate ? `${item.name} (по умолчанию)` : item.name}
          </Option>
        ))}
    </Select>
  );

  const renderSelectFormat = () => (
    <Select
      placeholder="Выберите формат"
      defaultValue="PDF"
      onChange={(value) => {
        setBillsMoDataModal({
          ...billsMoDataModal,
          formatType: value,
        });
      }}
    >
      {[{ value: "PDF" }, { value: "XLSX" }].map((item) => (
        <Option key={uuid()} value={item.value}>
          {item.value}
        </Option>
      ))}
    </Select>
  );

  const renderBodyModalReport = () => {
    return (
      <Form form={reportModalForm} labelAlign="left" {...layout} style={{ width: "100%" }}>
        <Row style={{ width: "100%" }}>
          <Col span={10}>
            <Form.Item label="Шаблон" name="reportTypeId">
              {renderSelectReportType()}
            </Form.Item>
            <Form.Item label="Формат" name="formatType">
              {renderSelectFormat()}
            </Form.Item>
          </Col>
          <Col span={13} offset={1}>
            <Form.Item wrapperCol={{ span: 24 }} label="" name="reportId">
              {renderSelectTemplates()}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };

  const onSearch = (values) => {
    if (values) {
      if (values["organization.property.stringValue"]) {
        values["organization.property.typeAlias"] =
          companyIdentityAttribute && companyIdentityAttribute;
      }
      values.periodFrom = toHttpFormatStartOfDay(values.periodDate[0]);
      values.periodTo = toHttpFormatEndOfDay(values.periodDate[1]);

      values.fromDateFrom =
        values.fromToDate && values.fromToDate[0]
          ? toHttpFormatStartOfDay(values.fromToDate[0])
          : "";
      values.fromDateTo =
        values.fromToDate && values.fromToDate[1] ? toHttpFormatEndOfDay(values.fromToDate[1]) : "";

      values.paidDateFrom =
        values.paidDate && values.paidDate[0] ? toHttpFormatStartOfDay(values.paidDate[0]) : "";
      values.paidDateTo =
        values.paidDate && values.paidDate[1] ? toHttpFormatEndOfDay(values.paidDate[1]) : "";

      values.id = values.id ? values.id.split(/\D/).filter(Boolean).map(Number) : "";

      values.periodDate = "";
      values.fromToDate = "";
      values.paidDate = "";
    }
    setSelectedRowKeys([]);
    handleSearchBills(values);
  };

  return (
    <>
      <div className="inner-row" style={{ height: "50px" }}>
        <Row justify="space-between" align="middle">
          <Col>
            <h1>Массовые операции по работе со счетами</h1>
          </Col>
        </Row>
      </div>
      <BulkBillsSearchFilters
        form={form}
        billsSearchParams={billsSearchParams}
        onSearch={onSearch}
        filtersCollapseState={filtersCollapseState}
        setFiltersCollapsState={setFiltersCollapsState}
        resetSearchPaymentsAndResetSetSelectedRowKeys={
          resetSearchPaymentsAndResetSetSelectedRowKeys
        }
      />
      <Row justify="end">
        <ToggleColumns tableName="bills-table" columns={columns} setColumns={setColumns} />
      </Row>
      <Table
        columns={columns.filter(({ hidden }) => !hidden)}
        dataSource={tableData}
        loading={checkIsLoading(extendedSearchBillsLoading)}
        size="small"
        pagination={false}
        scroll={{ y: getTableHeight() }}
        className="bulk-services__table"
        rowSelection={{
          selectedRowKeys,
          onChange: (selectedKeys) => {
            setSelectedRowKeys(selectedKeys);
          },
        }}
      />

      {renderFooter(selectedRowKeys)}
      <Modal
        visible={isModalVisible}
        onCancel={() => {
          setActiveModal(null)
          reportModalForm.resetFields()
        }}
        onOk={() => {
          setActiveModal(null);
          handlers[activeModal]();
          reportModalForm.resetFields()
        }}
        cancelText="Отмена"
        okText="Далее"
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
          fontSize: "16px",
        }}
      >
        <p className="bulk-bills__paragraph">{`Будет сформировано задание на ${modalText[activeModal]}`}</p>
        {modalText[activeModal] === modalText.send && renderBodyModalReport()}
      </Modal>
    </>
  );
};

export default BulkBills;
